import Entity from '../entity'

export default class HzLetterItems extends Entity<number>{
    Id:string;
    contactId:string;
    contactName:string;
    letterType:string;
    projectName:string;
    custName:string;
    createBy:string;
    sendBy:string;
    sendByName:string;
    sendRoute:string;
    sendWay:string="";
    execNotes:string;
    alertNotes:string;
    fileName:string;
    OutName:string;
    replyName:string;
    contactPerson:string;
    address:string;
    phone:string;
    fax:string;
    email:string;
    ccEmail:string;
    outFileName:Array<any>=[];
    statusId:string;
    letterReplyId:string;
    letterAmount:Array<any>=[];
    letterReply:Array<any>=[];
    approvalBy:string;
    outBy:string;
    inBy:string;
}